import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Target, Radio, Calendar, ShoppingBag, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { guidanceAPI } from '../../lib/api';
import { useAuth } from '../../context/AuthContext';

const ICONS = { target: Target, radio: Radio, calendar: Calendar, shopping: ShoppingBag };
const COLORS = {
  emerald: 'border-emerald-500/20 bg-emerald-500/5 text-emerald-400',
  rose: 'border-rose-500/20 bg-rose-500/5 text-rose-400',
  amber: 'border-amber-500/20 bg-amber-500/5 text-amber-400',
  blue: 'border-blue-500/20 bg-blue-500/5 text-blue-400',
};

export default function Bridges({ pageType, entityId }) {
  const { user } = useAuth();
  const [bridges, setBridges] = useState([]);

  useEffect(() => {
    if (!user || !entityId) return;
    guidanceAPI.getBridges(pageType, entityId)
      .then(r => setBridges(r.data?.bridges || []))
      .catch(() => {});
  }, [user, pageType, entityId]);

  if (bridges.length === 0) return null;

  return (
    <div className="space-y-2 mt-4" data-testid="bridges">
      <p className="text-[10px] font-bold text-zinc-500 uppercase tracking-wider">Related</p>
      {bridges.map((b, idx) => {
        const Icon = ICONS[b.icon] || Target;
        const colorClass = COLORS[b.color] || COLORS.emerald;
        return (
          <motion.div key={idx} initial={{ opacity: 0, x: -5 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: idx * 0.08 }}>
            <Link
              to={b.link}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-xl border transition-all hover:translate-x-0.5 ${colorClass}`}
              data-testid={`bridge-${idx}`}
            >
              <Icon size={14} className="flex-shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-xs font-bold truncate">{b.title}</p>
                <p className="text-[10px] opacity-60">{b.subtitle}</p>
              </div>
              <ChevronRight size={12} className="opacity-40 flex-shrink-0" />
            </Link>
          </motion.div>
        );
      })}
    </div>
  );
}
